"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputTokenConstants = exports.BC_INPUT_TOKEN_CONSTANTS_NUMBERS = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BC_INPUT_TOKEN = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-input-token");
exports.BC_INPUT_TOKEN_CONSTANTS_NUMBERS = {
    BACK_SPACE_ASCII_CODE: 8,
    DELETE_ASCII_CODE: 46,
    MAX_LENGTH_INPUT: 1
};
var BcInputTokenConstants = (function () {
    function BcInputTokenConstants() {
    }
    BcInputTokenConstants.BC_INPUT_TOKEN = "".concat(BC_INPUT_TOKEN);
    BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER = "".concat(BC_INPUT_TOKEN, "-container");
    BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER_INITIAL_FOCUS = "".concat(BC_INPUT_TOKEN, "-initial-focus");
    BcInputTokenConstants.BC_ALL_INPUTS_VALID = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-all-inputs-valid");
    BcInputTokenConstants.BC_ALL_INPUTS_ERROR = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-all-inputs-error");
    BcInputTokenConstants.BC_LABEL_BOTTOM = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-label-bottom-token");
    BcInputTokenConstants.BC_INPUT_TOKEN_FILLED = "".concat(BC_INPUT_TOKEN, "-filled");
    BcInputTokenConstants.BC_INPUT_TOKEN_BACK_SPACE_ASCII_CODE = exports.BC_INPUT_TOKEN_CONSTANTS_NUMBERS.BACK_SPACE_ASCII_CODE;
    BcInputTokenConstants.BC_INPUT_TOKEN_DELETE_ASCII_CODE = exports.BC_INPUT_TOKEN_CONSTANTS_NUMBERS.DELETE_ASCII_CODE;
    BcInputTokenConstants.BC_INPUT_TOKEN_MAX_LENGTH_INPUT = exports.BC_INPUT_TOKEN_CONSTANTS_NUMBERS.MAX_LENGTH_INPUT;
    BcInputTokenConstants.BC_INPUT_TOKEN_CLASS = 'bc-input';
    BcInputTokenConstants.BC_INPUT_TOKEN_MESSAGE_NUMBER_INPUTS = 'Ingresa el código de [NUM_INPUTS] dígitos';
    BcInputTokenConstants.BC_INPUT_TOKEN_MESSAGE_REQUIRED = 'Debe completar todos los campos para continuar';
    BcInputTokenConstants.BC_INPUT_TOKEN_MESSAGE_INPUT = 'Ingresar [NUM] dígito, Editar texto';
    BcInputTokenConstants.BC_INPUT_TOKEN_POSSITION_ARRAY = new Map([
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N1, 'primer'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N2, 'segundo'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N3, 'tercer'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N4, 'cuarto'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N5, 'quinto'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N6, 'sexto'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N7, 'septimo'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N8, 'octavo'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N9, 'noveno'],
        [common_constants_1.COMMON_CONSTANTS_NUMBERS.N10, 'décimo'],
    ]);
    BcInputTokenConstants.BC_STATE_ERROR = 'error';
    return BcInputTokenConstants;
}());
exports.BcInputTokenConstants = BcInputTokenConstants;
